import { useTranslation } from "react-i18next";

const CTASection = () => {
  const { t } = useTranslation();

  return (
    <section className="py-20">
      <div className="">
        <div className="bg-[rgb(0,73,69)] bg-radial-gradient rounded-3xl p-12 text-center mx-auto">
          <h2 className="text-3xl md:text-4xl font-bold mb-6 text-white">
            {t("migrationPage.CTA.title")}
          </h2>
          <p className="text-white/80 mb-10 max-w-md mx-auto">
            {t("migrationPage.CTA.description")}
          </p>
          <button className="bg-white text-[#004945] rounded-xl font-bold hover:scale-105 transition-transform">
            <a
              href="https://uplus.rw"
              target="_blank"
              rel="noreferrer"
              className="h-full w-full px-8 py-4 block"
            >
              {t("migrationPage.CTA.openApp")}
            </a>
          </button>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
